<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">An experienced information professional, Consonants has depicted her career’s most thought-provoking subject requests and has creatively answered them in her debut novel, <em>Dr Nathaniel Goodrich – The Plight of Divorcement</em>.</p><br/>
<p style="text-indent:0em">Consonants has also appeared in and choreographed runway shows, learning about executing graceful ideas.</p><br/>
<p style="text-indent:0em">Consonants lives in Australia where she enjoys attending cultural events, keeping fit, and gaming.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?07625832